import React, { useContext } from 'react';
import { Link } from 'gatsby';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons';
import { GlobalContext } from '../state/GlobalContext';
import mixtureGasData from '../data/mixture-gases.json'
import { getMatchedProductsData, generateProductName, generateCustomProductName, getCylinderSizeFormatted } from '../helpers/helper'
import Advert from '../components/sections/Advert';
import Banner from '../components/sections/Banner';
import Wrapper from "../components/structure/Wrapper"
import Quantity from '../components/form/Quantity';
import Seo from '../components/structure/Seo';

export default function Quote() {
    const { quoteItems, removeQuoteItem, updateQuoteItem, setExactStep } = useContext(GlobalContext);

    const removeItem = (e) => {
        const id = e.target.closest('.quote-item').dataset.productId;
        const type = e.target.closest('.quote-item').dataset.type;
        console.log(id, type);
        removeQuoteItem({ type: type, PR: id });
    }

    const updateQty = (e, item, qty) => {
        const type = e.target.closest('.quote-item').dataset.type;
        updateQuoteItem({type: type, PR: item, qty: qty});
    }

    return (
        <main className="overflow-hidden">
            <Seo title="Quote" />
            <Banner title="Your Mixture Gas Quote" />
            <Wrapper>
                    {
                        quoteItems.standard.length < 1 && quoteItems.custom.length < 1
                        ? <p className="my-5 md:my-10 text-xl text-primary font-bold">Your quote is currently empty</p>
                        : 
                        <div className="w-full text-left mb-5">
                            <div className="mb-5 lg:mb-10">
                                <div className="hidden md:grid grid-cols-5 gap-2 rounded-2xl shadow-lg bg-gradient-to-r from-white-darker to-white overflow-hidden mb-5">
                                    <span className="col-span-2 p-3 lg:p-5 font-normal uppercase">Product Name</span>
                                    <span className="p-3 lg:p-5 font-normal uppercase">Size</span>
                                    <span className="p-3 lg:p-5 font-normal uppercase">Quantity</span>
                                    <span className="p-3 lg:p-5 font-normal uppercase text-center">Remove</span>
                                </div>
                                {
                                    quoteItems.standard.map((item, index) => {
                                        const itemData = getMatchedProductsData(mixtureGasData, [parseInt(item.PR)])[0];
                                        return (
                                            <div key={index} data-product-id={itemData.PR} data-type="standard" className="quote-item md:grid grid-cols-5 gap-2 items-center shadow-lg rounded-2xl overflow-hidden mb-5 py-8 px-5 md:p-0 text-sm md:text-base">
                                                <div className="col-span-2 mb-4 md:mb-0 md:p-3 lg:p-5 w-full font-bold text-base"><span className="uppercase mr-5 md:hidden">Size:</span> {generateProductName(itemData)}</div>
                                                <div><span className="block mt-2 text-sm text-grey mb-2 md:mb-0"><span className="uppercase mr-5 md:hidden">Size:</span> {getCylinderSizeFormatted(itemData.size)}</span></div>
                                                <div className="flex items-start md:p-3 lg:p-5"><span className="uppercase mr-5 md:hidden">Quantity:</span><Quantity item={itemData.PR} qty={item.qty} updateQty={updateQty} /></div>
                                                <div className="mt-2 md:mt-0 md:p-3 lg:p-5 md:text-center"><button onClick={removeItem} className="text-secondary text-xl hover:text-grey-darkest" aria-label="remove item from quote"><FontAwesomeIcon icon={faTrashAlt} className="pointer-events-none" /></button></div>
                                            </div>
                                        )
                                    })
                                }
                                {
                                    quoteItems.custom.map((item, index) => {
                                        return (
                                            <div key={index} data-product-id={item.PR} data-type="custom" className="quote-item md:grid grid-cols-5 gap-2 items-center shadow-lg rounded-2xl overflow-hidden mb-5 py-8 px-5 md:p-0 text-sm md:text-base">
                                                <div className="col-span-2 mb-4 md:mb-0 md:p-3 lg:p-5 w-full font-bold text-base"><span dangerouslySetInnerHTML={{__html: generateCustomProductName(item)}}></span></div>
                                                <div className=""><span className="block mt-2 text-sm text-grey mb-2 md:mb-0"><span className="uppercase mr-5 md:hidden">Size:</span> {getCylinderSizeFormatted(item.size)}</span></div>
                                                <div className="flex items-start md:p-3 lg:p-5"><span className="uppercase mr-5 md:hidden">Quantity:</span><Quantity item={item.PR} qty={item.qty} updateQty={updateQty} /></div>
                                                <div className="mt-2 md:mt-0 md:p-3 lg:p-5 md:text-center"><button onClick={removeItem} className="text-secondary text-xl hover:text-grey-darkest" aria-label="remove item from quote"><FontAwesomeIcon icon={faTrashAlt} className="pointer-events-none" /></button></div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <div className="quote-footer flex justify-end">
                                <div className="md:flex items-center flex-wrap">
                                    <Link to="/"     className="inline-block w-48 mx-auto my-2 mr-3 py-4 md:px-5 uppercase text-center leading-none shadow-lg text-secondary tracking-wider rounded-full overflow-hidden border border-secondary bg-white hover:bg-white-dark transition-colors" onClick={() => setExactStep(1)}>Back</Link>
                                    <Link to="/send" className="inline-block w-48 mx-auto my-2 py-4 md:px-5 uppercase text-center leading-none shadow-lg text-white tracking-wider rounded-full overflow-hidden border border-secondary bg-secondary hover:bg-secondary-light transition-colors">Send Enquiry</Link>
                                </div>
                            </div>
                        </div>
                        
                    }

                    <Advert />
            </Wrapper>
        </main>
    );
}